import { render, staticRenderFns } from "./WarrantyClaimDetails.vue?vue&type=template&id=969234ce&"
import script from "./WarrantyClaimDetails.vue?vue&type=script&lang=js&"
export * from "./WarrantyClaimDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports